import css from './Footer.css';

const CURRENT_YEAR = new Date().getFullYear();
export const Footer = () => {
	return <div className={css.root}>Паприка Медиа. Все права защищены 2022-{CURRENT_YEAR}.</div>;
};
